import ApiService from '@/services/ApiService';

export default {
  new(payment) {
    return ApiService().post('/payment/new', payment);
  },
};
